import http from "../../utils/http";
import * as TYPES from '../../store/run/action-types.js';
import {isTimeInSameDayRange} from "../../utils";

// 运营
export function RunService(context) {
	let dispatch = context.$store.dispatch;
	const RUN__SET_AREA_ACTION = `run/${TYPES.RUN__SET_AREAS}`;
	const RUN__ADD_AREA_ACTION = `run/${TYPES.RUN__ADD_AREA}`;
	const RUN__SET_CURRENT_AREA_ACTION = `run/${TYPES.RUN__SET_CURRENT_AREA}`;
	const RUN__SET_CURRENT_AREA_INDEX_ACTION = `run/${TYPES.RUN__SET_CURRENT_AREA_INDEX}`;
	const RUN__SET_CURRENT_AREA_PICKER_LIST_ACTION = `run/${TYPES.RUN__SET_AREA_PICKER_LIST}`;
	function getAreas() {
		let areas = context.$store.state.run.areas;
		if (context.$UserService.isServiceManager()) {
			const supportAreaIds = context.$UserService.getSupportAreaIds();
			return areas.filter(area => {
				return supportAreaIds.includes(area.id);
			});
		}
		return areas;
	}
	function getCurrentAreaId() {
		return context.$store.getters['run/currentAreaId'];
	}
	return {
		/**
		 * 设置运营区域
		 * @param areas
		 */
		setAreas(areas = []) {
			dispatch(RUN__SET_AREA_ACTION, areas);
		},
		/**
		 * 添加运营区域
		 * @param area
		 */
		addArea(area = []) {
			dispatch(RUN__ADD_AREA_ACTION, area);
		},
		/**
		 * 获取默认区域索引
		 * @param {string} cityId 城市ID
		 * @param {number} [lng] 用户位置经度
		 * @param {number} [lat] 用户位置纬度
		 * @param {string} [userId] 用户ID
		 * @return {Promise<number>} 索引值，无默认时返回-1
		 */
		async fetchDefaultAreaIndex(cityId, lng, lat, userId) {
			console.log('fetchDefaultAreaIndex', cityId, lng, lat, userId);
			let url = '/area/getAreaId?';
			let query = Object.entries({cityId, lng, lat, userId}).filter(([k,v]) => !!k && !!v);
			query.forEach(([k, v]) => {
				url += `${k}=${v}&`;
			});
			try {
				let areas = getAreas() || [];
				const res = await http.get(url);
        const arr = (res || '').split(',')
        const areaId = arr[0]
        const isAreaPop = arr.length > 1 ? arr[1] === '1' : true
        const areaIndex = areas.findIndex(area => area.id + '' === areaId)
        console.log('areaId',res, areaId,areaIndex, isAreaPop)
				return {
          areaIndex,
          isAreaPop
        }
			} catch (e) {
				console.error('[ fetchDefaultAreaIndex ]', e);
				return {
          areaIndex: -1,
          isAreaPop: true
        }
			}
		},
		/**
		 * 设置当前运营区域
		 * @param {number} index
		 */
		setCurrentArea(index, isShowToast = true) {
			let areas = getAreas() || [];
			if (!areas.length) {
				return;
			}
			let currentArea = areas[index];
			const { isHubArea, isBookingTicket } = currentArea || {};
			dispatch(RUN__SET_CURRENT_AREA_ACTION, currentArea);
			// 设置区域ID
			const {id: areaId, lng, lat, area, stops, startRunTime, endRunTime, timeRangeList} = currentArea || {};
			context.$HomeService.setAreaId(areaId);
			dispatch(RUN__SET_CURRENT_AREA_INDEX_ACTION, index);
			let pickerList = areas.map((area, index) => {
				let {name} = area;
				return {
          label: name,
          value: index,
          id: areaId
        }
			});
			dispatch(RUN__SET_CURRENT_AREA_PICKER_LIST_ACTION, [pickerList]);
			// 设置运营中心点
			context.$MapService.setMapDataAreaCenterPos({lng, lat});
			// 单独汇总运营区域列表到地图服务
			context.$MapService.setMapDataAreas([area]);
			// 单独汇总运营站点列表到地图服务
			context.$MapService.setMapDataStops(stops);
      if(timeRangeList.length) {
        let inRunTimeRange = true
        for (let i = 0; i < timeRangeList.length; i++) {
          const item = timeRangeList[i]
          inRunTimeRange = isTimeInSameDayRange(item.startTime, item.endTime)
          if (inRunTimeRange) {
            break
          }
        }
				const isBookingMode = isHubArea && isBookingTicket
				// 枢纽站模式下，预约单不校验运营时间
        if (!inRunTimeRange && isShowToast && !isBookingMode) {
          context.$cheToast({
            type: 'fail',
            text: `当前不在运营时间内，该区域运营时间为${startRunTime}-${endRunTime}*`
          })
        }
      }
		},
		/**
		 * 获取当前选中区域
		 * @return string|null
		 */
		getCurrentAreaId
	};
}

export function install(Vue, context) {
	Vue.prototype.$RunService = RunService(context);
}
